import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { app } from './client';

export const db = getFirestore(app);

if (typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname)) {
  connectFirestoreEmulator(db, window.location.hostname, 8080);
}
